import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  saveLoadingById: false,
  trainingsLength: 0,
  trainings: [],
  training: {},
  trainingError: "",
  formError: "",
};

export default function TrainingReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_TRAINING:
      return { ...state, loading: action.payload };
    case actions.LOADING_TRAINING_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_TRAINING:
      return { ...state, saveLoading: action.payload };
    case actions.SAVE_LOADING_TRAINING_BY_ID:
      return { ...state, saveLoadingById: action.payload };
    case actions.GET_TRAINING:
      return {
        ...state,
        trainings: action.payload.trainings,
        trainingsLength: action.payload.trainingsLength,
      };
    case actions.GET_TRAINING_BY_ID:
      return {
        ...state,
        training: action.payload,
      };
    case actions.FORM_FAIL_TRAINING:
      return { ...state, formError: action.payload };
    case actions.TRAINING_FAIL:
      return { ...state, trainingError: action.payload };
    default:
      return state;
  }
}
